var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { staticClass: "td-comment" }, [
    !!_vm.order.params.comment
      ? _c(
          "a",
          {
            staticClass: "show_comment",
            attrs: { href: "#", id: "show_comment_" + _vm.order.id },
            on: { click: _vm.show }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.order.view.comment))]),
            _vm._v(" "),
            _c("div", { staticClass: "comment-modal" }, [
              _c("div", { staticClass: "comment-modal__content" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.order.params.comment) +
                    "\n            "
                )
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56fda95d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56fda95d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/table/fields/CommentField.vue
// module id = 176
// module chunks = 1